import { useRef, useState, useEffect } from 'react';
import { TerminalHeader } from './TerminalHeader';
import { TerminalContent } from './TerminalContent';
import { TerminalInput } from './TerminalInput';
import { useTerminal } from '../hooks/useTerminal';
import { focusInput } from '../utils/focus';

export function Terminal() {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isAnimating, setIsAnimating] = useState(false);

  const {
    messages,
    isTyping,
    chatMode,
    inputMode,
    isInitializing,
    handleCommand,
    toggleChatMode,
    handleCTAClick,
    handleExitEmailMode,
    handleClear,
  } = useTerminal({ messagesEndRef, inputRef });

  // Focus input when animation completes
  useEffect(() => {
    if (!isAnimating && !isTyping && !isInitializing && inputRef.current) {
      const timer = setTimeout(() => {
        focusInput(inputRef);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isAnimating, isTyping, isInitializing]);

  const handleAnimationStateChange = (animating: boolean) => {
    setIsAnimating(animating);
  };

  return (
    <div className="w-full max-w-6xl h-[90vh] bg-[#1a1a1a] rounded-xl shadow-2xl border border-[#2a2a2a] flex flex-col overflow-hidden">
      <TerminalHeader onClear={handleClear} />
      <TerminalContent
        messages={messages}
        isTyping={isTyping}
        messagesEndRef={messagesEndRef}
        onCommand={handleCommand}
        isInitializing={isInitializing}
        onCTAClick={handleCTAClick}
        onAnimationStateChange={handleAnimationStateChange}
      />
      <TerminalInput
        onCommand={handleCommand}
        disabled={isTyping || isInitializing || isAnimating}
        inputRef={inputRef}
        chatMode={chatMode}
        onToggleChatMode={toggleChatMode}
        inputMode={inputMode}
        onExitEmailMode={handleExitEmailMode}
      />
    </div>
  );
}
